var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// server/services/lan-manager/lib/lan-manager.constants.js
var require_lan_manager_constants = __commonJS({
  "server/services/lan-manager/lib/lan-manager.constants.js"(exports, module) {
    var PARAMS = {
      MAC: "DEVICE_MAC",
      NAME: "DEVICE_NAME",
      MANUFACTURER: "MANUFACTURER"
    };
    var VARIABLES = {
      PRESENCE_STATUS: "LANMANAGER_PRESENCE_STATUS",
      PRESENCE_FREQUENCY: "LANMANAGER_PRESENCE_FREQUENCY",
      IP_MASKS: "LANMANAGER_IP_MASKS"
    };
    var PRESENCE_STATUS = {
      ENABLED: "enabled",
      DISABLED: "disabled"
    };
    var TIMERS = {
      PRESENCE: 12e4,
      SCAN: 6e4
    };
    var SCAN_OPTIONS = {
      IP_FAMILY: ["IPv4"]
    };
    var UTILS = {
      IP_MASK_OPTION_SEPARATOR: "|",
      IP_MASK_VALUE_SEPARATOR: ":"
    };
    module.exports = { PARAMS, VARIABLES, PRESENCE_STATUS, TIMERS, SCAN_OPTIONS, UTILS };
  }
});
const __cjsModule = require_lan_manager_constants();
export default __cjsModule;
export const PARAMS = __cjsModule.PARAMS;
export const VARIABLES = __cjsModule.VARIABLES;
export const PRESENCE_STATUS = __cjsModule.PRESENCE_STATUS;
export const TIMERS = __cjsModule.TIMERS;
export const SCAN_OPTIONS = __cjsModule.SCAN_OPTIONS;
export const UTILS = __cjsModule.UTILS;
